import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/shared/lib/supabase'
import { useCurrentUser } from '@/features/auth/hooks/use-current-user'

export type PaymentType = 'scoping' | 'development' | 'subscription'
export type PaymentStatus = 'pending' | 'paid' | 'failed' | 'refunded'

export interface Payment {
  id: string
  organization_id: string
  project_id?: string
  team_id?: string
  type: PaymentType
  amount: number // in cents
  currency: string
  status: PaymentStatus
  invoice_number?: string
  invoice_pdf_url?: string
  created_at: string
  paid_at?: string
  // Joined data
  project?: {
    name: string
  }
}

async function fetchPayments(organizationId: string): Promise<Payment[]> {
  const { data, error } = await supabase
    .from('payments')
    .select(`
      *,
      project:projects(name)
    `)
    .eq('organization_id', organizationId)
    .order('created_at', { ascending: false })

  if (error) {
    throw new Error(error.message)
  }

  return (data || []) as Payment[]
}

export function usePayments() {
  const { user } = useCurrentUser()

  return useQuery({
    queryKey: ['payments', user?.organization_id],
    queryFn: () => fetchPayments(user!.organization_id!),
    enabled: !!user?.organization_id,
  })
}
